export default __webpack_public_path__ + "static/cleaning2-af7814c856218c3651e2d2600f40ac85.jpg";